"use client";
import { formControlLabelClasses } from "@mui/material/FormControlLabel";
import { formLabelClasses } from "@mui/material/FormLabel";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  cssVariables: {
    cssVarPrefix: "informa-mui",
    colorSchemeSelector: ".informa-%s-display-style",
  },
  typography: {
    fontFamily: "var(--informa-font-setup-body, system-ui)",
    h1: {
      fontFamily: "var(--informa-font-setup-header, system-ui)",
    },
    h2: {
      fontFamily: "var(--informa-font-setup-header, system-ui)",
    },
    h3: {
      fontFamily: "var(--informa-font-setup-header, system-ui)",
    },
    h4: {
      fontFamily: "var(--informa-font-setup-header, system-ui)",
    },
    h5: {
      fontFamily: "var(--informa-font-setup-header, system-ui)",
    },
    h6: {
      fontFamily: "var(--informa-font-setup-header, system-ui)",
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          ...theme.typography.body1,

          [`& .${formLabelClasses.asterisk}`]: {
            color: theme.vars.palette.error.light,
          },
        }),
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          [`& .${formControlLabelClasses.asterisk}`]: {
            color: theme.vars.palette.error.light,
          },
        }),
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: ({ theme }) => ({
          ...theme.typography.caption,
          marginLeft: 0,
        }),
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          [`& .${inputLabelClasses.asterisk}`]: {
            color: theme.vars.palette.error.light,
          },
        }),
      },
    },
  },
});

export default theme;
